import { BaseKey } from '@refinedev/core';
import { message } from 'antd';
import { AxiosInstance } from 'axios';

import { TICKETS_URLS } from '@/constants/urls';
import FileData from '@/model/General/FileData';
import { Ticket } from '@/model/Ticket/Ticket';

class TicketApi {
  axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }
  uploadFiles(files: FileData[], ticketId: BaseKey): Promise<any[]> {
    if (!files || files.length === 0) {
      return Promise.resolve([]);
    } else {
      const uploadPromises: Promise<any>[] = [];

      files.forEach(file => {
        if (!file.blobFile) {
          return;
        }

        const formData = new FormData();

        formData.append('file', file.blobFile);

        uploadPromises.push(
          this.axiosInstance
            .post(`${TICKETS_URLS.TICKETS}/${ticketId}/files`, formData)
            .then(response => {
              return response.data;
            })
            .catch(error => {
              message.error(error.response?.data?.message || 'Error uploading file');

              console.error(`Error uploading file ${file.title}:`, error);
              throw error;
            }),
        );
      });

      return Promise.all(uploadPromises);
    }
  }

  removeFiles(files: FileData[], ticketId: BaseKey): Promise<any[]> {
    if (!files || files.length === 0) {
      return Promise.resolve([]);
    } else {
      const removePromises: Promise<any>[] = [];

      files.forEach(file => {
        removePromises.push(
          this.axiosInstance
            .delete(`${TICKETS_URLS.TICKETS}/${ticketId}/files/${file.id}`)
            .then(response => {
              return response.data;
            })
            .catch(error => {
              console.error(`Error removing file ${file.title}:`, error);
              throw error;
            }),
        );
      });

      return Promise.all(removePromises);
    }
  }

  updateTicket(ticketData: Partial<Ticket>): Promise<any> {
    if (!ticketData.id) {
      return Promise.reject(new Error('Ticket ID is required for update'));
    }

    return this.axiosInstance
      .patch(`${TICKETS_URLS.TICKETS}/${ticketData.id}`, ticketData)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        message.error(error.response?.data?.message || 'Error updating ticket');

        console.error(`Error updating ticket ${ticketData.id}:`, error);
        throw error;
      });
  }
}

export default TicketApi;
